// Response contract for POST api/v2/users/prelogin, discriminated by `outcome`. A missing account comes back as
// PASSWORD (never a distinct NOT_FOUND) so the response can't be used to enumerate accounts.
export const PreloginOutcome = {
  Password: "PASSWORD",
  Unregistered: "UNREGISTERED",
  SsoRedirect: "SSO_REDIRECT",
  SsoIdpOnly: "SSO_IDP_ONLY"
} as const

export type PreloginSso = {
  idpEntityId: string
}

export type PreloginResponse =
  | { outcome: typeof PreloginOutcome.SsoRedirect; sso: PreloginSso }
  | { outcome: typeof PreloginOutcome.Password; sso: PreloginSso | null }
  | { outcome: typeof PreloginOutcome.Unregistered }
  | { outcome: typeof PreloginOutcome.SsoIdpOnly }
